var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.6 20a1.598 1.598 0 0 1-1.131-2.731l5.289-5.289-5.089-5.269a1.601 1.601 0 0 1 2.303-2.224l6.18 6.4a1.6 1.6 0 0 1-.02 2.244l-6.4 6.4A1.6 1.6 0 0 1 8.6 20",
    clipRule: "evenodd"
  })));
};
export default SvgChevronRight;